import React from 'react';
import styles from './Typing.module.css';
function Typing() {
  return (
    <div id="typing" className={styles.ticontainer}>
      <div className={styles.tiblock}>
        <div className={styles.tidot}></div>
        <div className={styles.tidot}></div>
        <div className={styles.tidot}></div>
      </div>
    </div>
  );
}
export default Typing;
